import { Button, Form, Radio, Tooltip } from 'antd'
import { rules } from 'modules/FormItems'
import React from 'react'
import CustomSpin from '../../../elements/CustomSpin'

const Cell = ({ value, tooltip }) => (
  <div className="h-12">{tooltip ? <Tooltip title={tooltip}>{value}</Tooltip> : value}</div>
)
const RowCell = ({ value, tooltip }) => (
  <div className="">{tooltip ? <Tooltip title={tooltip}>{value}</Tooltip> : value}</div>
)

const RadioBoxes = ({ len = 0, _cols, value, getFieldDecorator, path }) => {
  const cells = [...Array(len).keys()]

  return (
    <div className={`col-start-2 col-end-${cells.length + 2}`}>
      {getFieldDecorator(path, {
        initialValue: value || _cols.find((i) => i.default).key,
        rules: rules.select,
      })(
        <Radio.Group
          style={{
            display: 'flex',
            justifyContent: 'space-around',
          }}>
          {cells.map((i) => (
            <Cell value={<Radio value={_cols[i].key} tooltip={_cols[i].tooltip} />} />
          ))}
        </Radio.Group>
      )}
    </div>
  )
}

function RatingSystemForm(props) {
  const { template, fetching, submit, data, submitting, isNew, update } = props


  const results = data?.results || []
  const { cols = [], rows = [] } = template
  const { getFieldDecorator } = props.form

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <div className={`grid grid-cols-${cols.length + 1} text-center`}>
          <RowCell value={' '} />
          {cols.map((col) => (
            <Cell value={col.value} tooltip={col.tooltip} />
          ))}
          {rows.map((row) => (
            <>
              <RowCell value={row.value} tooltip={row.tooltip} />
              <RadioBoxes
                {...{
                  getFieldDecorator,
                  path: row.key,
                  len: cols.length,
                  value: results[row.key],
                  _cols: cols,
                }}
              />
            </>
          ))}
        </div>
      </Form>

      <Button style={{ marginTop: '10px' }} loading={submitting} onClick={() => submit() || update()} type="primary">
        {isNew ? 'Submit' : 'Update'}
      </Button>
    </CustomSpin>
  )
}

export default Form.create()(RatingSystemForm)
